import { IPersonalData } from '../common';

export interface ILinkedAccount {
  id: string;
  adverityConnectionTypeId: number;
  adverityConnection: {
    id: number;
    name: string;
    metadata_slack: number;
    stack: number;
    app: number;
    isAuthorized: boolean;
  };
}

export interface ICustomerActions {
  firstActionCompleted: boolean;
  profileUpdated: boolean;
}

export interface IGetCustomPageResponse {
  displayName: string;
  pathName?: string;
  url?: string;
  reportType: string;
}

export interface ICustomer {
  customerId: string;
  customerType?: string;
  businessType?: string;
  personalData?: IPersonalData;
  avatarUrl?: string;
  linkedAccounts?: Array<ILinkedAccount>;
  isApproved?: boolean;
  actions?: ICustomerActions;
  isAdmin?: boolean;
  reportingContainerName?: string;
  isAgreedToMarketingCommunication?: boolean;
  customPages?: Array<IGetCustomPageResponse>;
}

export type IGetCustomerResponseData = ICustomer;

export interface IUpdateCustomerRequestData {
  customerType: string;
  businessType: string;
  personalData: IPersonalData;
  isAgreedToMarketingCommunication: boolean;
}

export type IUpdateCustomerResponseData = ICustomer;

export interface ICustomerProfile {
  email: string;
  personalData: IPersonalData;
  avatarUrl: string;
  phoneNumber: string;
  about: string;
  created: string;
  domain: string;
  id: string;
  linkedInUrl: string;
  location: string;
  languages?: Array<string>;
  platforms: Array<string>;
  customerType: {
    value: string;
  };
}

export type IGetCustomerProfileResponseData = ICustomerProfile;

export type IUpdateCustomerProfileRequestData = Partial<ICustomerProfile>;

export type IGetOtherCustomerProfileResponseData = ICustomerProfile;

export interface INotLinkedAccount {
  key: string;
  connectionTypeId: number;
  isAuthorized: boolean;
}

export interface IDashboard {
  notLinkedAccounts: Array<INotLinkedAccount>;
  opportunityReportRequested: boolean;
}

export type IGetSupplierDashboardResponseData = IDashboard;

export type IGetDemandDashboardResponseData = IDashboard;

export interface IGetCustomerFullNameResponseData {
  customerFullName: string;
}

export enum PreferencesType {
  PERSONAL_INFORMATION = 'personal-information',
  ACCOUNTS_AND_LINKING = 'accounts-and-linking',
  ACCOUNTS_LINKING_BETA = 'accounts-linking-beta',
  USER_MANAGEMENT = 'user-management',
}

export interface IGetCustomerLinkedAccountsResponseData {
  linkedAccounts: Array<ILinkedAccount>;
}

export interface IUploadAvatarResponse {
  avatarUrl: string;
}
